import React, { Component } from "react";
import { connect } from "react-redux";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Loader from "react-loader-spinner";
import moment from "moment";
import {
  getwebinarAttendees,
  getWebinarFiltersData,
  getSearchWebinarAttendees,
  allAttendeesCount,
} from "../../redux/admin/financial/financialactions";
import { getAllWebinars } from "../../redux/admin/webinar/webinarActions";
import { urlapi } from "../../config/urlapi";
import Select from "react-select";
import Axios from "axios";
const columns = [
  {
    name: "Attendence ID",
    label: "Attendence ID",
    options: {
      filter: false,
    },
  },
  {
    name: "PEC No",
    label: "PEC No",
    options: {
      filter: true,
      display: true,
    },
  },
  {
    name: "Discipline",
    label: "Discipline",
    options: {
      filter: false,
      display: true,
    },
  },
  {
    name: "User Name",
    label: "User Name",
    options: {
      filter: false,
      searchable: true,
    },
  },
  {
    name: "User Email",
    label: "User Email",
    options: {
      filter: false,
    },
  },
  {
    name: "Phone Number",
    label: "Phone Number",
    options: {
      filter: false,
    },
  },
  {
    name: "Course Name",
    label: "Course Name",
    options: {
      filter: true,
    },
  },
  {
    name: "Session Name",
    label: "Session Name",
    options: {
      filter: true,
    },
  },
  {
    name: "Session Start Time",
    label: "Session Start Time",
    options: {
      filter: false,
    },
  },
  {
    name: "Session End Time",
    label: "Session End Time",
    options: {
      filter: false,
    },
  },
  {
    name: "Duration",
    label: "Duration",
    options: {
      filter: false,
    },
  },
  {
    name: "Attendence Percent",
    label: "Attendence Percent",
    options: {
      filter: false,
    },
  },
];
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "500px",
    backgroundColor: "#e0eadf",
    border: "none",
    color: "black",
    height: "300px",
    overflowY: "hidden",
    "z-index": 9999,
  },
  overlay: {
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.35)",
  },
};
class WebinarSurvey extends Component {
  state = {
    load: false,
    data: [],
    realData: [],
    filterOptionsState: false,
    allowPagination: true,
    simpleOptionsState: true,
    searchOptionsState: false,
    limit: 25,
    offset: 0,
    perPage: 25,
    count: 1,
    renderServerSide: true,
    searchType: [
      { label: "Email", value: "userinfo.PrimaryEmail" },
      { label: "Full Name", value: "userinfo.FullName" },
    ],
    selectedType: "",
    search: "",
    webinars: [],
    selectedCourse: null,

    surveyReport: null,
  surveyAnswerKey: null,
  passingCriteria: "60",
  attendancePassingCriteria: "60",
  };

  constructor(props) {
    super(props);

    this.searchEmailInput = React.createRef();
    this.searchNameInput = React.createRef();
    this.searchTypeInput = React.createRef();
    this.searchTextInput = React.createRef();
    this.searchPecInput = React.createRef();
    this.searchDisciplineInput = React.createRef();

    // this.searchFilter = this.searchFilter.bind(this);
  }

  componentDidMount() {
    this.allAttendeesCount();
    this.getwebinarAttendees();
    this.fetchWebinars();
  }

  fetchWebinars = () => {
    this.props
      .getAllWebinars()
      .then((res) => {
        const webinars = res.map((webinar) => ({
          label: webinar.Course_Name,
          value: webinar.CourseID,
        }));
        // Add "All Webinars" option
        webinars.unshift({ label: "All Webinars", value: null });
        console.log("webinar fetched...", webinars);
        this.setState({ webinars });
      })
      .catch((err) => {
        console.log("Error fetching webinars:", err);
      });
  };

  // Handle course selection
  handleCourseChange = (selectedOption) => {
    this.setState({ selectedCourse: selectedOption }, () => {
      this.getwebinarAttendees(); // Fetch attendees for the selected course
    });
  };

  getwebinarAttendees = () => {
    this.setState({ load: true }); // Show loader

    const { selectedCourse, limit, offset } = this.state;
    const webinarId = selectedCourse ? selectedCourse.value : null; // Use selected course ID or empty

    this.props
      .getwebinarAttendees({ limit, offset, webinarId })
      .then((res) => {
        const temp = res.data.map((item) => ({
          "Attendence ID": item.attendence_id,
          "User Name": item.FullName,
          "User Email": item.PrimaryEmail,
          "Phone Number": item.Primary_Contact_No,
          "Course Name": item.Course_Name,
          "Session Name": item.Session_Name,
          "Session Start Time": moment(item.Session_StartDate).format(
            "hh:mm a - DD/MM/YYYY"
          ),
          "Session End Time": moment(item.Session_EndDate).format(
            "hh:mm a - DD/MM/YYYY"
          ),
          Duration: item.duration,
          "Attendence Percent": item.percent,
          "PEC No": item.PEC_REG_NO,
          Discipline: item.discipline,
        }));

        this.setState({
          data: temp,
          realData: temp,
          load: false, // Hide loader
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ load: false }); // Hide loader on error
      });
  };

  downloadexcel = async (courseId, courseName) => {
    try {
      const response = await fetch(
        `${urlapi}/zoom/downloadWebinarAttendeeSheet`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ courseId }),
        }
      );

      if (response.ok) {
        // Create a blob from the response
        const blob = await response.blob();

        // Create a link element to trigger the download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        // const contentDisposition = response.headers.get('content-disposition');
        a.download = `attendees_${courseName}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Failed to download the sheet");
      }
    } catch (error) {
      console.error("Error downloading the sheet:", error);
    }
  };

  changePage = (page, sortOrder) => {
    console.log("onchange..", page);
    this.setState(
      {
        offset: page * this.state.perPage,
        page: page,
      },
      () => {
        this.getwebinarAttendees();
      }
    );
  };
  changeFilter = (data) => {
    console.log("Inside change filter: ", data);

    let newdata = [];
    data.map((item, index) => {
      if (!(item.length === 0)) {
        switch (index) {
          case 1: {
            newdata.push({ "userinfo.PEC_REG_NO": item[0] });
            break;
          }
          case 2: {
            newdata.push({ "userinfo.discipline": item[0] });
            break;
          }
          case 6: {
            newdata.push({ "courses.Course_Name": item[0] });
            break;
          }
          case 7: {
            newdata.push({ "course_session.Session_Name": item[0] });
            break;
          }
        }
      }
    });
    if (newdata.length === 0) {
      console.log("Inside if: ", newdata);
      this.setState({
        data: this.state.realData,
        allowPagination: true,
        load: false,
      });
    } else {
      console.log("Else if: ", newdata);

      this.props
        .getWebinarFiltersData(newdata)
        .then((res) => {
          console.log("Got filter webinars: ", res);

          let filterCount = res.length;
          newdata.push({ limit: this.state.limit, offset: this.state.offset });

          let temp = [];

          for (let i = 0; i < res.length; i++) {
            temp.push({
              "Attendence ID": res[i].attendence_id,
              "User Name": res[i].FullName,
              "User Email": res[i].PrimaryEmail,
              "Phone Number": res[i].Primary_Contact_No,
              "Course Name": res[i].Course_Name,
              "Session Name": res[i].Session_Name,
              "Session Start Time": moment(res[i].Session_StartDate).format(
                "hh:mm a - DD/MM/YYYY "
              ),
              "Session End Time": moment(res[i].Session_EndDate).format(
                "hh:mm a - DD/MM/YYYY "
              ),
              Duration: res[i].duration,
              "Attendence Percent": res[i].percent,
              "PEC No": res[i].PEC_REG_NO,
              Discipline: res[i].discipline,
            });
          }
          this.setState({
            filterOptionsState: true,
            simpleOptionsState: false,
            searchOptionsState: false,
            data: temp,
            perPage: 25,
            count: filterCount,
            load: false,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  allAttendeesCount = () => {
    this.props
      .allAttendeesCount()
      .then((res) => {
        let count = Math.floor(res.data[0].count);
        this.setState({ count: count });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  changePageSearch = (tableState) => {
    this.setState(
      {
        filterOptionsState:
          tableState.searchText === null ||
          tableState.searchText === "" ||
          !tableState.searchText
            ? false
            : true,
      },
      () => {
        // console.log('Server Side State: ', this.state.renderServerSide);
        // console.log('Search Text: ', tableState.searchText);
      }
    );
  };
  changeWebinarRows = (num) => {
    this.setState(
      {
        limit: num,
      },
      () => {
        this.getwebinarAttendees();
        this.allAttendeesCount();
      }
    );
  };
  resetWebinarFilters = () => {
    this.searchEmailInput.current.value = "";
    this.searchNameInput.current.value = "";
    this.searchPecInput.current.value = "";
    this.searchDisciplineInput.current.value = "";
    this.setState(
      {
        allowPagination: true,
        filterOptionsState: false,
        searchOptionsState: false,
        simpleOptionsState: true,
      },
      () => {
        this.getwebinarAttendees();
        this.allAttendeesCount();
      }
    );
  };

  searchData = () => {
    let searchEmail = this.searchEmailInput?.current?.value;

    let searchName = this.searchNameInput?.current?.value;

    let searchTextValue = this.searchTextInput?.current?.value;

    let searchPecValue = this.searchPecInput?.current?.value;

    let searchDisciplineValue = this.searchDisciplineInput?.current?.value;

    if (
      searchEmail ||
      searchName ||
      (searchTextValue && this.state.selectedType !== "") ||
      searchPecValue ||
      searchDisciplineValue
    ) {
      this.setState(
        {
          load: true,
        },
        () => {
          let data = [];

          let searchTypeValue = this.state.selectedType;

          data.push({ type: searchTypeValue });
          data.push({ search: searchTextValue });
          data.push({ email: searchEmail });
          data.push({ name: searchName });
          data.push({ pecNo: searchPecValue });
          data.push({ discipline: searchDisciplineValue });

          let newdata = [];
          let itemType = "";
          data.map((item, index) => {
            itemType = item["type"]?.label;

            if (!(item.length === 0)) {
              switch (index) {
                case 0: {
                  if (itemType && itemType === "Email") {
                    newdata.push({ "userinfo.PrimaryEmail": searchTextValue });
                  } else if (itemType && itemType === "Full Name") {
                    newdata.push({ "userinfo.FullName": searchTextValue });
                  }
                  break;
                }
                // case 1: {
                //   if (item['discipline'] !== "") {
                //     newdata.push({ "userinfo.discipline": item['discipline'] });
                //   }
                //   break;
                // }
                case 2: {
                  if (item["email"]) {
                    newdata.push({ "userinfo.PrimaryEmail": item["email"] });
                  }
                  break;
                }
                case 3: {
                  if (item["name"]) {
                    newdata.push({ "userinfo.FullName": item["name"] });
                  }
                  break;
                }
                case 4: {
                  if (item["pecNo"]) {
                    newdata.push({ "userinfo.PEC_REG_NO": item["pecNo"] });
                  }
                  break;
                }
                case 5: {
                  if (item["discipline"]) {
                    newdata.push({ "userinfo.discipline": item["discipline"] });
                  }
                  break;
                }
              }
            }
          });

          console.log("NEW DATA: ", newdata);

          this.props
            .getSearchWebinarAttendees(newdata)
            .then((res) => {
              console.log("Search res: ", res);
              let searchLength = res.length;
              let temp = [];
              for (let i = 0; i < res.length; i++) {
                temp.push({
                  "Attendence ID": res[i].attendence_id,
                  "User Name": res[i].FullName,
                  "User Email": res[i].PrimaryEmail,
                  "Phone Number": res[i].Primary_Contact_No,
                  "Course Name": res[i].Course_Name,
                  "Session Name": res[i].Session_Name,
                  "Session Start Time": moment(res[i].Session_StartDate).format(
                    "hh:mm a - DD/MM/YYYY "
                  ),
                  "Session End Time": moment(res[i].Session_EndDate).format(
                    "hh:mm a - DD/MM/YYYY "
                  ),
                  Duration: res[i].duration,
                  "Attendence Percent": res[i].percent,
                  "PEC No": res[i].PEC_REG_NO,
                  Discipline: res[i].discipline,
                });
              }
              this.setState({
                load: false,
                data: temp,
                count: searchLength,
                allowPagination: true,
                searchOptionsState: true,
                filterOptionsState: false,
                simpleOptionsState: false,
              });
            })
            .catch((err) => {
              this.setState({
                load: false,
              });
              console.log("Search Error: ", err);
            });
        }
      );
    }
  };

  handleTextInput = (event) => {
    this.setState({ ...this.state, search: event.target.value });
  };

  searchFilter = (selectedOption) => {
    this.setState({
      selectedType: selectedOption,
      // searchOptionsState: true,
      // filterOptionsState: false,
      // simpleOptionsState: false,
    });
  };
//new code for survey
// handleSurveyReportUpload = (event) => {
//     console.log('function called', event)
//     const file = event.target?.files?.[0];
//     if (file && file.name.endsWith(".csv")) {
//       this.setState({ surveyReport: file });
//     } else {
//       alert("Please upload a valid CSV file for the survey report.");
//       this.setState({ surveyReport: null });
//     }
//   };
  
  
//   handleSurveyAnswerKeyUpload = (event) => {

//     const file = event.target.files[0];
//     console.log('file...',file)
//     if (file && file.type === "text/csv") {
//       this.setState({ surveyAnswerKey: file });
//     } else {
//       alert("Please upload a valid CSV file for the answer key.");
//     }
//   };
  
// Fixed file upload handlers
handleSurveyReportUpload = (event) => {
    // Make sure we're getting the actual event with a target before proceeding
    if (event && event.target && event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('Survey report file uploaded:', file.name);
      
      if (file.name.endsWith(".csv") || file.type === "text/csv") {
        this.setState({ surveyReport: file });
      } else {
        alert("Please upload a valid CSV file for the survey report.");
        // Reset the file input
        event.target.value = null;
        this.setState({ surveyReport: null });
      }
    } else {
      console.error('Invalid event or missing target in handleSurveyReportUpload:', event);
      alert("Error uploading file. Please try again.");
    }
  };
  
  handleSurveyAnswerKeyUpload = (event) => {
    // Make sure we're getting the actual event with a target before proceeding
    if (event && event.target && event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('Survey answer key file uploaded:', file.name);
      
      if (file.name.endsWith(".csv") || file.type === "text/csv") {
        this.setState({ surveyAnswerKey: file });
      } else {
        alert("Please upload a valid CSV file for the answer key.");
        // Reset the file input
        event.target.value = null;
        this.setState({ surveyAnswerKey: null });
      }
    } else {
      console.error('Invalid event or missing target in handleSurveyAnswerKeyUpload:', event);
      alert("Error uploading file. Please try again.");
    }
  };

  handlePassingCriteriaChange = (event) => {
    this.setState({ passingCriteria: event.target.value });
  };

  handleAttendancePassingCriteriaChange = (event) => {
    this.setState({ attendancePassingCriteria: event.target.value });
  };
  
  // Placeholder for form submission function
  handleUpload = () => {
    const { surveyReport, surveyAnswerKey, passingCriteria } = this.state;
  
    if (!surveyReport || !surveyAnswerKey || !passingCriteria) {
      alert("Please upload both CSV files and enter passing criteria.");
      return;
    }
  
    const formData = new FormData();
    formData.append("survey_report", surveyReport);
    formData.append("survey_answer_key", surveyAnswerKey);
    formData.append("passing_criteria", passingCriteria);
  
    Axios
      .post(urlapi + "msg/upload_survey_documents", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("Upload response:", res.data);
        alert("Files uploaded successfully.");
      })
      .catch((err) => {
        console.error("Upload failed:", err);
        alert("File upload failed.");
      });
  };

  handleSubmit = () => {
    const { selectedCourse, passingCriteria, attendancePassingCriteria } = this.state;
  
    if (!selectedCourse) {
      alert("Please select a course before submitting.");
      return;
    }
  
    if (!passingCriteria || isNaN(passingCriteria)) {
      alert("Please enter a valid quiz passing criteria.");
      return;
    }

    if (!attendancePassingCriteria || isNaN(attendancePassingCriteria)) {
      alert("Please enter a valid attendance passing criteria.");
      return;
    }
  
    const payload = {
      courseId: selectedCourse.value,
      passingCriteria: passingCriteria,
      attendancePassingCriteria: attendancePassingCriteria,
    };
  
    Axios.post(urlapi + "msg/get_survey_result", payload)
      .then((res) => {
        console.log("Quiz result response:", res.data);
  
        if (res.data.message ) {
          alert("Quiz report generated successfully!");
  
         
      }})
      .catch((err) => {
        console.error("Error generating Quiz results:", err);
        alert("Failed to generate results.");
      });
  };
  
  
  
  // Function to download the sample CSV file for the answer key
  downloadSampleCSV = () => {
    const link = document.createElement("a");
    link.href = "/assets/survey_answer_key.csv";
    link.setAttribute("download", "survey_answer_key.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  
  // Function to download the sample CSV file for the Zoom survey report
  downloadZoomSurveyReportCSV = () => {
    const link = document.createElement("a");
    link.href = "/assets/survey_report.csv";
    link.setAttribute("download", "survey_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  

  render() {
    const options = {
      responsive: "vertical",
      tableBodyHeight: "600px",
      tableBodyMaxHeight: "",
      filter: true,
      search: true,
      rowsPerPage: this.state.perPage,
      pagination: this.state.allowPagination,
      onDownload: () => {
        if (!this.state.selectedCourse) {
          alert("Please select a webinar first.");
          return false;
        }

        this.downloadexcel(
          this.state.selectedCourse.value,
          this.state.selectedCourse.label
        );
        return false;
      },
      serverSide:
        this.state.filterOptionsState || this.state.searchOptionsState
          ? false
          : true,
      rowsPerPageOptions: [25, 50, 75, 100],
      count: this.state.count,
      page: this.state.page,
      filterType: "dropdown",
      customToolbarSelect: () => {},
      onTableChange: (action, tableState) => {
        console.log("action...", action, "tableState...", tableState);
        this.state.filterOptionsState || this.state.searchOptionsState
          ? ""
          : action === "changePage"
          ? this.changePage(tableState.page, tableState.sortOrder)
          : "";

        if (action === "filterChange") {
          this.changeFilter(tableState.filterList);
        }
        if (action === "search") {
          this.changePageSearch(tableState);
        }
      },
      onChangeRowsPerPage: (num) => {
        console.log("numbers...", num);
        if (
          this.state.filterOptionsState === true ||
          this.state.searchOptionsState === true
        ) {
        } else {
          this.setState({ perPage: num, page: 0 });
          this.changeWebinarRows(num);
        }
      },
      onFilterChange: (changedColumn, filterList, type) => {
        if (type === "reset") {
          this.resetWebinarFilters();
        }
      },
      onFilterChipClose: (index, removedFilter, filterList) => {
        let temp = [];
        filterList.map((value, index) => {
          for (let i = 0; i <= value.length; i++) {
            temp.push(i);
          }
        });
        // console.log("TEMP LENGTH: ", temp.length);
        if (temp.length === 12) {
          this.resetWebinarFilters();
        }
      },
    };
    const theme = createMuiTheme({
      overrides: {
        MUIDataTableSelectCell: {
          expandDisabled: {
            visibility: "hidden",
          },
        },
        MUIDataTableToolbar: {
          filterPaper: {
            width: "450px !important",
            height: "auto !important",
          },
        },
      },
    });

    console.log("webinars fetched...", this.state.webinars);
    const { webinars, selectedCourse } = this.state;
    console.log("web...", selectedCourse);
    return (
      <React.Fragment>
        <>
          <h4 className="regular_font fs-26 mtb-35">Webinar Quiz</h4>

          <hr></hr>
          <div className="col-md-12">
            <div className="row">
            
              <div className="col-md-2" style={{ zIndex: 1000 }}>
                <label className="bm-0">Course</label>
                <Select
                  className="mtb-10"
                  options={webinars}
                  value={selectedCourse}
                  onChange={this.handleCourseChange}
                  placeholder="Select Course"
                />
              </div>

              
            </div>
          </div>
          <hr></hr>
        </>

        {this.state.load === true ? (
          <div className="loaderDiv text-center">
            <Loader type="Oval" color="#06580e" height={80} width={80} />
          </div>
        ) : (
          <div className="mt-50">
            <MuiThemeProvider theme={theme}>
  <div className="col-md-12">
    <div className="row">
      {/* Existing fields */}
      <div className="col-md-12">
        <div className="row">
          {/* Download buttons */}
          <div className="col-md-12">
              <div className="d-flex justify-content-start">
                <button
                  className="btn admin_btn_new text-center white w-150p mr-2 bold mtb-10"
                >
                  <Link
                    to="/assets/document/pdf/quiz_answer_key.csv"
                    className="btn btn-success bold font_sans fz_14"
                    target="_blank"
                    download
                  >
                    Download Answer Key Sample CSV
                  </Link>
                </button>

                <button
                  className="btn admin_btn_new text-center white w-150p ml-2 bold mtb-10"
                >
                  <Link
                    to="/assets/document/pdf/quiz_report.csv"
                    className="btn btn-success bold font_sans fz_14"
                    target="_blank"
                    download
                  >
                    Download Zoom Quiz Report Sample CSV
                  </Link>
                </button>
              </div>
            </div>


<div className="col-md-6 mt-2">
  <label className="bm-0">Upload Quiz Report (CSV)</label>
  <div className="input-group">
    <div className="custom-file">
      <input
        type="file"
        className="custom-file-input"
        id="surveyReportFile"
        accept=".csv"
        onChange={this.handleSurveyReportUpload}
      />
      <label className="custom-file-label" htmlFor="surveyReportFile">
        {this.state.surveyReport ? this.state.surveyReport.name : "Choose file"}
      </label>
    </div>
  </div>
  {this.state.surveyReport && (
    <small className="text-success">
      File selected: {this.state.surveyReport.name}
    </small>
  )}
</div>

<div className="col-md-6 mt-2">
  <label className="bm-0">Upload Quiz Answer Key (CSV)</label>
  <div className="input-group">
    <div className="custom-file">
      <input
        type="file"
        className="custom-file-input"
        id="surveyAnswerKeyFile"
        accept=".csv"
        onChange={this.handleSurveyAnswerKeyUpload}
      />
      <label className="custom-file-label" htmlFor="surveyAnswerKeyFile">
        {this.state.surveyAnswerKey ? this.state.surveyAnswerKey.name : "Choose file"}
      </label>
    </div>
  </div>
  {this.state.surveyAnswerKey && (
    <small className="text-success">
      File selected: {this.state.surveyAnswerKey.name}
    </small>
  )}
</div>

<div className="col-md-12">
            <button
              className="btn admin_btn_new text-center white w-150p float-right bold mtb-10"
              onClick={this.handleUpload}
            >
              upload both files
            </button>
          </div>

          {/* Passing criteria input */}
          <div className="col-md-6">
            <label className="bm-0">Quiz Passing Criteria (%)</label>
            <input
              type="number"
              className="form-control"
              value={this.state.passingCriteria}
              onChange={this.handlePassingCriteriaChange}
              placeholder="Enter passing criteria in percentage"
            />
            <small className="text-muted">If you do not want to calculate  on quiz, just write 0</small>
          </div>
          <div className="col-md-6">
            <label className="bm-0">Attendance Passing Criteria (%)</label>
            <input
              type="number"
              className="form-control"
              value={this.state.attendancePassingCriteria}
              onChange={this.handleAttendancePassingCriteriaChange}
              placeholder="Enter passing criteria in percentage"
            />
            <small className="text-muted">If you do not want to calculate  on attendance, just write 0</small>
          </div>

          {/* Submit button */}
          <div className="col-md-12">
            <button
              className="btn admin_btn_new text-center white w-150p float-right bold mtb-10"
              onClick={this.handleSubmit}
            >
              generate survey result
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</MuiThemeProvider>

          </div>
        )}
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    payments: state.financialData.coursepayments,
    registrations: state.financialData.registrations,
  };
}
export default connect(mapStateToProps, {
  getwebinarAttendees,
  getWebinarFiltersData,
  getSearchWebinarAttendees,
  allAttendeesCount,
  getAllWebinars,
})(WebinarSurvey);
